import cn from 'classnames';
import classes from './Tag.module.css';
import { Paragraph } from '../Paragraph';
import { ReactNode } from 'react';

export type TagVariants = 'info' | 'success' | 'warning' | 'danger' | 'zero' | 'neutral' | 'primary' | 'subtle';
export type TagSizes = 'sm' | 'md' | 'ml' | 'lg';

const TagColorVariantsMap: Record<TagVariants, string> = {
  info: 'var(--info-light)',
  success: 'var(--success-light)',
  warning: 'var(--warning-light)',
  danger: 'var(--danger-light)',
  zero: 'var(--line)',
  neutral: 'var(--lighter-gray)',
  primary: 'var(--primary-transparent-2)',
  subtle: 'var(--bg-light)',
};

const TagDarkColorVariantsMap: Record<TagVariants, string> = {
  info: 'var(--text-dark)',
  success: 'var(--success-dark)',
  warning: 'var(--warning-dark)',
  danger: 'var(--danger-dark)',
  zero: 'var(--text-dark)',
  neutral: 'var(--text-mediumdark)',
  primary: 'var(--primary)',
  subtle: 'var(--text-light)',
};

type TagProps = {
  children: ReactNode;
  variant?: TagVariants;
  size?: TagSizes;
};

export const Tag = ({ children, variant = 'info', size = 'md' }: TagProps) => {
  const className = cn(classes.tag, classes[size]);
  return (
    <div
      className={className}
      style={{
        backgroundColor: TagColorVariantsMap[variant],
      }}
      role="note"
    >
      <Paragraph
        size={size}
        style={{ color: TagDarkColorVariantsMap[variant] }}
      >
        {children}
      </Paragraph>
    </div>
  );
};
